"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: crypto/crypto-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcrypto%2Fcrypto-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoServiceClient = exports.cryptoErrorCodeToJSON = exports.cryptoErrorCodeFromJSON = exports.GetChartResponse = exports.GetChartRequest = exports.SetUserDefinedLimitResponse = exports.SetUserDefinedLimitRequest = exports.GetDefaultCryptoBuyLimitResponse = exports.GetDefaultCryptoBuyLimitRequest = exports.GetQuoteResponse = exports.GetQuoteRequest = exports.ConfirmEligibilityResponse = exports.ConfirmEligibilityRequest = exports.BuyResponse = exports.BuyRequest = exports.LiquidateResponse = exports.LiquidateRequest = exports.GetAccountsResponse = exports.GetAccountsRequest = exports.DeactivateEnrollmentResponse = exports.DeactivateEnrollmentRequest = exports.GetEnrollmentResponse = exports.GetEnrollmentRequest = exports.EnrollUserResponse = exports.EnrollUserRequest = exports.GetIndexResponse = exports.GetIndexRequest = exports.CryptoAccount = exports.Index = exports.CryptoErrorCode = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../common/amount");
const chart_1 = require("../common/chart");
const price_1 = require("../common/price");
const quote_1 = require("../common/quote");
const crypto_1 = require("./crypto");
const enrollment_1 = require("./enrollment");
const protobufPackage = 'com.step.crypto.proto';
var CryptoErrorCode;
(function (CryptoErrorCode) {
    CryptoErrorCode["INVALID_ERROR_CODE"] = "INVALID_ERROR_CODE";
    CryptoErrorCode["EMAIL_REQUIRED"] = "EMAIL_REQUIRED";
    CryptoErrorCode["UNSUPPORTED_COUNTRY"] = "UNSUPPORTED_COUNTRY";
    CryptoErrorCode["UNSUPPORTED_CURRENCY"] = "UNSUPPORTED_CURRENCY";
    CryptoErrorCode["ENROLLMENT_REQUIRED"] = "ENROLLMENT_REQUIRED";
    CryptoErrorCode["FULL_SSN_REQUIRED"] = "FULL_SSN_REQUIRED";
    CryptoErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    CryptoErrorCode["UNSUPPORTED_REGION"] = "UNSUPPORTED_REGION";
    CryptoErrorCode["INSUFFICIENT_TOTAL_AMOUNT"] = "INSUFFICIENT_TOTAL_AMOUNT";
    CryptoErrorCode["TRADING_UNAVAILABLE"] = "TRADING_UNAVAILABLE";
    CryptoErrorCode["PARTICIPANT_ALREADY_EXISTS"] = "PARTICIPANT_ALREADY_EXISTS";
    CryptoErrorCode["INVALID_AGE"] = "INVALID_AGE";
    CryptoErrorCode["INVALID_CUSTODIAN_RELATIONSHIP"] = "INVALID_CUSTODIAN_RELATIONSHIP";
    CryptoErrorCode["UNKNOWN_CUSTODIAN"] = "UNKNOWN_CUSTODIAN";
    CryptoErrorCode["INVALID_CUSTODIAN_PARTICIPANT_CODE"] = "INVALID_CUSTODIAN_PARTICIPANT_CODE";
    CryptoErrorCode["INSUFFICIENT_FUNDS_FOR_TRANSFER"] = "INSUFFICIENT_FUNDS_FOR_TRANSFER";
    CryptoErrorCode["INSUFFICIENT_AUTHORIZATION"] = "INSUFFICIENT_AUTHORIZATION";
    CryptoErrorCode["NEGATIVE_AMOUNT"] = "NEGATIVE_AMOUNT";
    CryptoErrorCode["ACCOUNT_IS_NOT_AVAILABLE"] = "ACCOUNT_IS_NOT_AVAILABLE";
    CryptoErrorCode["QUOTE_NOT_FOUND"] = "QUOTE_NOT_FOUND";
    CryptoErrorCode["TRANSFER_NOT_FOUND"] = "TRANSFER_NOT_FOUND";
    CryptoErrorCode["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
    CryptoErrorCode["INVALID_ADDRESS_PO_BOX"] = "INVALID_ADDRESS_PO_BOX";
    CryptoErrorCode["INVALID_STATUS_FOR_ENROLLMENT"] = "INVALID_STATUS_FOR_ENROLLMENT";
    CryptoErrorCode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CryptoErrorCode || (exports.CryptoErrorCode = CryptoErrorCode = {}));
function createBaseIndex() {
    return { timestampMs: '0', underlying: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.Index = {
    fromJSON(object) {
        const message = {
            timestampMs: isSet(object.timestampMs) ? globalThis.String(object.timestampMs) : '0',
            underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.timestampMs !== '0') {
            obj.timestampMs = message.timestampMs;
        }
        if (message.underlying !== '') {
            obj.underlying = message.underlying;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.Index.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIndex();
        message.timestampMs = object.timestampMs ?? '0';
        message.underlying = object.underlying ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseCryptoAccount() {
    return { balance: amount_1.Amount.fromPartial({}), updatedAtMs: '0' };
}
exports.CryptoAccount = {
    fromJSON(object) {
        const message = {
            balance: isSet(object.balance) ? amount_1.Amount.fromJSON(object.balance) : amount_1.Amount.fromPartial({}),
            updatedAtMs: isSet(object.updatedAtMs) ? globalThis.String(object.updatedAtMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.balance !== undefined) {
            obj.balance = amount_1.Amount.toJSON(message.balance);
        }
        if (message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.CryptoAccount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCryptoAccount();
        message.balance = (object.balance !== undefined && object.balance !== null)
            ? amount_1.Amount.fromPartial(object.balance)
            : amount_1.Amount.fromPartial({});
        message.updatedAtMs = object.updatedAtMs ?? '0';
        return message;
    },
};
function createBaseGetIndexRequest() {
    return { underlying: '', quoted: '' };
}
exports.GetIndexRequest = {
    fromJSON(object) {
        const message = {
            underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
            quoted: isSet(object.quoted) ? globalThis.String(object.quoted) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.underlying !== '') {
            obj.underlying = message.underlying;
        }
        if (message.quoted !== '') {
            obj.quoted = message.quoted;
        }
        return obj;
    },
    create(base) {
        return exports.GetIndexRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetIndexRequest();
        message.underlying = object.underlying ?? '';
        message.quoted = object.quoted ?? '';
        return message;
    },
};
function createBaseGetIndexResponse() {
    return { index: exports.Index.fromPartial({}) };
}
exports.GetIndexResponse = {
    fromJSON(object) {
        const message = {
            index: isSet(object.index) ? exports.Index.fromJSON(object.index) : exports.Index.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.index !== undefined) {
            obj.index = exports.Index.toJSON(message.index);
        }
        return obj;
    },
    create(base) {
        return exports.GetIndexResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetIndexResponse();
        message.index = (object.index !== undefined && object.index !== null)
            ? exports.Index.fromPartial(object.index)
            : exports.Index.fromPartial({});
        return message;
    },
};
function createBaseEnrollUserRequest() {
    return {};
}
exports.EnrollUserRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.EnrollUserRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseEnrollUserRequest();
        return message;
    },
};
function createBaseEnrollUserResponse() {
    return { enrollment: enrollment_1.Enrollment.fromPartial({}) };
}
exports.EnrollUserResponse = {
    fromJSON(object) {
        const message = {
            enrollment: isSet(object.enrollment)
                ? enrollment_1.Enrollment.fromJSON(object.enrollment)
                : enrollment_1.Enrollment.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.enrollment !== undefined) {
            obj.enrollment = enrollment_1.Enrollment.toJSON(message.enrollment);
        }
        return obj;
    },
    create(base) {
        return exports.EnrollUserResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEnrollUserResponse();
        message.enrollment = (object.enrollment !== undefined && object.enrollment !== null)
            ? enrollment_1.Enrollment.fromPartial(object.enrollment)
            : enrollment_1.Enrollment.fromPartial({});
        return message;
    },
};
function createBaseGetEnrollmentRequest() {
    return {};
}
exports.GetEnrollmentRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetEnrollmentRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetEnrollmentRequest();
        return message;
    },
};
function createBaseGetEnrollmentResponse() {
    return { enrollment: undefined, eligibility: undefined };
}
exports.GetEnrollmentResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.enrollment)) {
            message.enrollment = enrollment_1.Enrollment.fromJSON(object.enrollment);
        }
        if (isSet(object.eligibility)) {
            message.eligibility = crypto_1.EligibilityRequirements.fromJSON(object.eligibility);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.enrollment !== undefined) {
            obj.enrollment = enrollment_1.Enrollment.toJSON(message.enrollment);
        }
        if (message.eligibility !== undefined) {
            obj.eligibility = crypto_1.EligibilityRequirements.toJSON(message.eligibility);
        }
        return obj;
    },
    create(base) {
        return exports.GetEnrollmentResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetEnrollmentResponse();
        message.enrollment = (object.enrollment !== undefined && object.enrollment !== null)
            ? enrollment_1.Enrollment.fromPartial(object.enrollment)
            : undefined;
        message.eligibility = (object.eligibility !== undefined && object.eligibility !== null)
            ? crypto_1.EligibilityRequirements.fromPartial(object.eligibility)
            : undefined;
        return message;
    },
};
function createBaseDeactivateEnrollmentRequest() {
    return {};
}
exports.DeactivateEnrollmentRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DeactivateEnrollmentRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDeactivateEnrollmentRequest();
        return message;
    },
};
function createBaseDeactivateEnrollmentResponse() {
    return {};
}
exports.DeactivateEnrollmentResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DeactivateEnrollmentResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDeactivateEnrollmentResponse();
        return message;
    },
};
function createBaseGetAccountsRequest() {
    return {};
}
exports.GetAccountsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetAccountsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetAccountsRequest();
        return message;
    },
};
function createBaseGetAccountsResponse() {
    return { accounts: [] };
}
exports.GetAccountsResponse = {
    fromJSON(object) {
        const message = {
            accounts: globalThis.Array.isArray(object?.accounts)
                ? object.accounts.map((e) => exports.CryptoAccount.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accounts?.length) {
            obj.accounts = message.accounts.map((e) => exports.CryptoAccount.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetAccountsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAccountsResponse();
        message.accounts = object.accounts?.map((e) => exports.CryptoAccount.fromPartial(e)) || [];
        return message;
    },
};
function createBaseLiquidateRequest() {
    return { quantity: undefined, total: undefined };
}
exports.LiquidateRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.quantity)) {
            message.quantity = crypto_1.Quantity.fromJSON(object.quantity);
        }
        if (isSet(object.total)) {
            message.total = crypto_1.Total.fromJSON(object.total);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quantity !== undefined) {
            obj.quantity = crypto_1.Quantity.toJSON(message.quantity);
        }
        if (message.total !== undefined) {
            obj.total = crypto_1.Total.toJSON(message.total);
        }
        return obj;
    },
    create(base) {
        return exports.LiquidateRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLiquidateRequest();
        message.quantity = (object.quantity !== undefined && object.quantity !== null)
            ? crypto_1.Quantity.fromPartial(object.quantity)
            : undefined;
        message.total = (object.total !== undefined && object.total !== null)
            ? crypto_1.Total.fromPartial(object.total)
            : undefined;
        return message;
    },
};
function createBaseLiquidateResponse() {
    return { executedQuote: quote_1.ExecutedQuote.fromPartial({}) };
}
exports.LiquidateResponse = {
    fromJSON(object) {
        const message = {
            executedQuote: isSet(object.executedQuote)
                ? quote_1.ExecutedQuote.fromJSON(object.executedQuote)
                : quote_1.ExecutedQuote.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.executedQuote !== undefined) {
            obj.executedQuote = quote_1.ExecutedQuote.toJSON(message.executedQuote);
        }
        return obj;
    },
    create(base) {
        return exports.LiquidateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLiquidateResponse();
        message.executedQuote = (object.executedQuote !== undefined && object.executedQuote !== null)
            ? quote_1.ExecutedQuote.fromPartial(object.executedQuote)
            : quote_1.ExecutedQuote.fromPartial({});
        return message;
    },
};
function createBaseBuyRequest() {
    return { quantity: undefined, total: undefined };
}
exports.BuyRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.quantity)) {
            message.quantity = crypto_1.Quantity.fromJSON(object.quantity);
        }
        if (isSet(object.total)) {
            message.total = crypto_1.Total.fromJSON(object.total);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quantity !== undefined) {
            obj.quantity = crypto_1.Quantity.toJSON(message.quantity);
        }
        if (message.total !== undefined) {
            obj.total = crypto_1.Total.toJSON(message.total);
        }
        return obj;
    },
    create(base) {
        return exports.BuyRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBuyRequest();
        message.quantity = (object.quantity !== undefined && object.quantity !== null)
            ? crypto_1.Quantity.fromPartial(object.quantity)
            : undefined;
        message.total = (object.total !== undefined && object.total !== null)
            ? crypto_1.Total.fromPartial(object.total)
            : undefined;
        return message;
    },
};
function createBaseBuyResponse() {
    return { executedQuote: quote_1.ExecutedQuote.fromPartial({}) };
}
exports.BuyResponse = {
    fromJSON(object) {
        const message = {
            executedQuote: isSet(object.executedQuote)
                ? quote_1.ExecutedQuote.fromJSON(object.executedQuote)
                : quote_1.ExecutedQuote.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.executedQuote !== undefined) {
            obj.executedQuote = quote_1.ExecutedQuote.toJSON(message.executedQuote);
        }
        return obj;
    },
    create(base) {
        return exports.BuyResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBuyResponse();
        message.executedQuote = (object.executedQuote !== undefined && object.executedQuote !== null)
            ? quote_1.ExecutedQuote.fromPartial(object.executedQuote)
            : quote_1.ExecutedQuote.fromPartial({});
        return message;
    },
};
function createBaseConfirmEligibilityRequest() {
    return {};
}
exports.ConfirmEligibilityRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ConfirmEligibilityRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseConfirmEligibilityRequest();
        return message;
    },
};
function createBaseConfirmEligibilityResponse() {
    return { requirements: [] };
}
exports.ConfirmEligibilityResponse = {
    fromJSON(object) {
        const message = {
            requirements: globalThis.Array.isArray(object?.requirements)
                ? object.requirements.map((e) => crypto_1.EligibilityRequirement.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.requirements?.length) {
            obj.requirements = message.requirements.map((e) => crypto_1.EligibilityRequirement.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ConfirmEligibilityResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConfirmEligibilityResponse();
        message.requirements = object.requirements?.map((e) => crypto_1.EligibilityRequirement.fromPartial(e)) ||
            [];
        return message;
    },
};
function createBaseGetQuoteRequest() {
    return { side: quote_1.QuoteSide.INVALID_SIDE, quantity: undefined, total: undefined };
}
exports.GetQuoteRequest = {
    fromJSON(object) {
        const message = {
            side: isSet(object.side) ? (0, quote_1.quoteSideFromJSON)(object.side) : quote_1.QuoteSide.INVALID_SIDE,
        };
        if (isSet(object.quantity)) {
            message.quantity = crypto_1.Quantity.fromJSON(object.quantity);
        }
        if (isSet(object.total)) {
            message.total = crypto_1.Total.fromJSON(object.total);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.side !== quote_1.QuoteSide.INVALID_SIDE) {
            obj.side = (0, quote_1.quoteSideToJSON)(message.side);
        }
        if (message.quantity !== undefined) {
            obj.quantity = crypto_1.Quantity.toJSON(message.quantity);
        }
        if (message.total !== undefined) {
            obj.total = crypto_1.Total.toJSON(message.total);
        }
        return obj;
    },
    create(base) {
        return exports.GetQuoteRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuoteRequest();
        message.side = object.side ?? quote_1.QuoteSide.INVALID_SIDE;
        message.quantity = (object.quantity !== undefined && object.quantity !== null)
            ? crypto_1.Quantity.fromPartial(object.quantity)
            : undefined;
        message.total = (object.total !== undefined && object.total !== null)
            ? crypto_1.Total.fromPartial(object.total)
            : undefined;
        return message;
    },
};
function createBaseGetQuoteResponse() {
    return { quote: quote_1.Quote.fromPartial({}) };
}
exports.GetQuoteResponse = {
    fromJSON(object) {
        const message = {
            quote: isSet(object.quote) ? quote_1.Quote.fromJSON(object.quote) : quote_1.Quote.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quote !== undefined) {
            obj.quote = quote_1.Quote.toJSON(message.quote);
        }
        return obj;
    },
    create(base) {
        return exports.GetQuoteResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuoteResponse();
        message.quote = (object.quote !== undefined && object.quote !== null)
            ? quote_1.Quote.fromPartial(object.quote)
            : quote_1.Quote.fromPartial({});
        return message;
    },
};
function createBaseGetDefaultCryptoBuyLimitRequest() {
    return {};
}
exports.GetDefaultCryptoBuyLimitRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetDefaultCryptoBuyLimitRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetDefaultCryptoBuyLimitRequest();
        return message;
    },
};
function createBaseGetDefaultCryptoBuyLimitResponse() {
    return {
        id: '',
        minAmount: amount_1.Amount.fromPartial({}),
        maxAmount: amount_1.Amount.fromPartial({}),
        step: amount_1.Amount.fromPartial({}),
    };
}
exports.GetDefaultCryptoBuyLimitResponse = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            minAmount: isSet(object.minAmount)
                ? amount_1.Amount.fromJSON(object.minAmount)
                : amount_1.Amount.fromPartial({}),
            maxAmount: isSet(object.maxAmount)
                ? amount_1.Amount.fromJSON(object.maxAmount)
                : amount_1.Amount.fromPartial({}),
            step: isSet(object.step) ? amount_1.Amount.fromJSON(object.step) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.minAmount !== undefined) {
            obj.minAmount = amount_1.Amount.toJSON(message.minAmount);
        }
        if (message.maxAmount !== undefined) {
            obj.maxAmount = amount_1.Amount.toJSON(message.maxAmount);
        }
        if (message.step !== undefined) {
            obj.step = amount_1.Amount.toJSON(message.step);
        }
        return obj;
    },
    create(base) {
        return exports.GetDefaultCryptoBuyLimitResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetDefaultCryptoBuyLimitResponse();
        message.id = object.id ?? '';
        message.minAmount = (object.minAmount !== undefined && object.minAmount !== null)
            ? amount_1.Amount.fromPartial(object.minAmount)
            : amount_1.Amount.fromPartial({});
        message.maxAmount = (object.maxAmount !== undefined && object.maxAmount !== null)
            ? amount_1.Amount.fromPartial(object.maxAmount)
            : amount_1.Amount.fromPartial({});
        message.step = (object.step !== undefined && object.step !== null)
            ? amount_1.Amount.fromPartial(object.step)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseSetUserDefinedLimitRequest() {
    return { id: '', limit: amount_1.Amount.fromPartial({}) };
}
exports.SetUserDefinedLimitRequest = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            limit: isSet(object.limit) ? amount_1.Amount.fromJSON(object.limit) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.limit !== undefined) {
            obj.limit = amount_1.Amount.toJSON(message.limit);
        }
        return obj;
    },
    create(base) {
        return exports.SetUserDefinedLimitRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetUserDefinedLimitRequest();
        message.id = object.id ?? '';
        message.limit = (object.limit !== undefined && object.limit !== null)
            ? amount_1.Amount.fromPartial(object.limit)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseSetUserDefinedLimitResponse() {
    return {};
}
exports.SetUserDefinedLimitResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetUserDefinedLimitResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetUserDefinedLimitResponse();
        return message;
    },
};
function createBaseGetChartRequest() {
    return { underlying: '', timeRange: chart_1.ChartTimeRange.INVALID_CHART_TIME_RANGE };
}
exports.GetChartRequest = {
    fromJSON(object) {
        const message = {
            underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : '',
            timeRange: isSet(object.timeRange)
                ? (0, chart_1.chartTimeRangeFromJSON)(object.timeRange)
                : chart_1.ChartTimeRange.INVALID_CHART_TIME_RANGE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.underlying !== '') {
            obj.underlying = message.underlying;
        }
        if (message.timeRange !== chart_1.ChartTimeRange.INVALID_CHART_TIME_RANGE) {
            obj.timeRange = (0, chart_1.chartTimeRangeToJSON)(message.timeRange);
        }
        return obj;
    },
    create(base) {
        return exports.GetChartRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChartRequest();
        message.underlying = object.underlying ?? '';
        message.timeRange = object.timeRange ?? chart_1.ChartTimeRange.INVALID_CHART_TIME_RANGE;
        return message;
    },
};
function createBaseGetChartResponse() {
    return { prices: [] };
}
exports.GetChartResponse = {
    fromJSON(object) {
        const message = {
            prices: globalThis.Array.isArray(object?.prices)
                ? object.prices.map((e) => price_1.Price.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.prices?.length) {
            obj.prices = message.prices.map((e) => price_1.Price.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetChartResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChartResponse();
        message.prices = object.prices?.map((e) => price_1.Price.fromPartial(e)) || [];
        return message;
    },
};
function cryptoErrorCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ERROR_CODE':
            return CryptoErrorCode.INVALID_ERROR_CODE;
        case 1:
        case 'EMAIL_REQUIRED':
            return CryptoErrorCode.EMAIL_REQUIRED;
        case 2:
        case 'UNSUPPORTED_COUNTRY':
            return CryptoErrorCode.UNSUPPORTED_COUNTRY;
        case 3:
        case 'UNSUPPORTED_CURRENCY':
            return CryptoErrorCode.UNSUPPORTED_CURRENCY;
        case 4:
        case 'ENROLLMENT_REQUIRED':
            return CryptoErrorCode.ENROLLMENT_REQUIRED;
        case 5:
        case 'FULL_SSN_REQUIRED':
            return CryptoErrorCode.FULL_SSN_REQUIRED;
        case 6:
        case 'INSUFFICIENT_FUNDS':
            return CryptoErrorCode.INSUFFICIENT_FUNDS;
        case 7:
        case 'UNSUPPORTED_REGION':
            return CryptoErrorCode.UNSUPPORTED_REGION;
        case 8:
        case 'INSUFFICIENT_TOTAL_AMOUNT':
            return CryptoErrorCode.INSUFFICIENT_TOTAL_AMOUNT;
        case 9:
        case 'TRADING_UNAVAILABLE':
            return CryptoErrorCode.TRADING_UNAVAILABLE;
        case 10:
        case 'PARTICIPANT_ALREADY_EXISTS':
            return CryptoErrorCode.PARTICIPANT_ALREADY_EXISTS;
        case 11:
        case 'INVALID_AGE':
            return CryptoErrorCode.INVALID_AGE;
        case 12:
        case 'INVALID_CUSTODIAN_RELATIONSHIP':
            return CryptoErrorCode.INVALID_CUSTODIAN_RELATIONSHIP;
        case 13:
        case 'UNKNOWN_CUSTODIAN':
            return CryptoErrorCode.UNKNOWN_CUSTODIAN;
        case 14:
        case 'INVALID_CUSTODIAN_PARTICIPANT_CODE':
            return CryptoErrorCode.INVALID_CUSTODIAN_PARTICIPANT_CODE;
        case 15:
        case 'INSUFFICIENT_FUNDS_FOR_TRANSFER':
            return CryptoErrorCode.INSUFFICIENT_FUNDS_FOR_TRANSFER;
        case 16:
        case 'INSUFFICIENT_AUTHORIZATION':
            return CryptoErrorCode.INSUFFICIENT_AUTHORIZATION;
        case 17:
        case 'NEGATIVE_AMOUNT':
            return CryptoErrorCode.NEGATIVE_AMOUNT;
        case 18:
        case 'ACCOUNT_IS_NOT_AVAILABLE':
            return CryptoErrorCode.ACCOUNT_IS_NOT_AVAILABLE;
        case 19:
        case 'QUOTE_NOT_FOUND':
            return CryptoErrorCode.QUOTE_NOT_FOUND;
        case 20:
        case 'TRANSFER_NOT_FOUND':
            return CryptoErrorCode.TRANSFER_NOT_FOUND;
        case 21:
        case 'SERVICE_UNAVAILABLE':
            return CryptoErrorCode.SERVICE_UNAVAILABLE;
        case 22:
        case 'INVALID_ADDRESS_PO_BOX':
            return CryptoErrorCode.INVALID_ADDRESS_PO_BOX;
        case 23:
        case 'INVALID_STATUS_FOR_ENROLLMENT':
            return CryptoErrorCode.INVALID_STATUS_FOR_ENROLLMENT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CryptoErrorCode.UNRECOGNIZED;
    }
}
exports.cryptoErrorCodeFromJSON = cryptoErrorCodeFromJSON;
function cryptoErrorCodeToJSON(object) {
    switch (object) {
        case CryptoErrorCode.INVALID_ERROR_CODE:
            return 'INVALID_ERROR_CODE';
        case CryptoErrorCode.EMAIL_REQUIRED:
            return 'EMAIL_REQUIRED';
        case CryptoErrorCode.UNSUPPORTED_COUNTRY:
            return 'UNSUPPORTED_COUNTRY';
        case CryptoErrorCode.UNSUPPORTED_CURRENCY:
            return 'UNSUPPORTED_CURRENCY';
        case CryptoErrorCode.ENROLLMENT_REQUIRED:
            return 'ENROLLMENT_REQUIRED';
        case CryptoErrorCode.FULL_SSN_REQUIRED:
            return 'FULL_SSN_REQUIRED';
        case CryptoErrorCode.INSUFFICIENT_FUNDS:
            return 'INSUFFICIENT_FUNDS';
        case CryptoErrorCode.UNSUPPORTED_REGION:
            return 'UNSUPPORTED_REGION';
        case CryptoErrorCode.INSUFFICIENT_TOTAL_AMOUNT:
            return 'INSUFFICIENT_TOTAL_AMOUNT';
        case CryptoErrorCode.TRADING_UNAVAILABLE:
            return 'TRADING_UNAVAILABLE';
        case CryptoErrorCode.PARTICIPANT_ALREADY_EXISTS:
            return 'PARTICIPANT_ALREADY_EXISTS';
        case CryptoErrorCode.INVALID_AGE:
            return 'INVALID_AGE';
        case CryptoErrorCode.INVALID_CUSTODIAN_RELATIONSHIP:
            return 'INVALID_CUSTODIAN_RELATIONSHIP';
        case CryptoErrorCode.UNKNOWN_CUSTODIAN:
            return 'UNKNOWN_CUSTODIAN';
        case CryptoErrorCode.INVALID_CUSTODIAN_PARTICIPANT_CODE:
            return 'INVALID_CUSTODIAN_PARTICIPANT_CODE';
        case CryptoErrorCode.INSUFFICIENT_FUNDS_FOR_TRANSFER:
            return 'INSUFFICIENT_FUNDS_FOR_TRANSFER';
        case CryptoErrorCode.INSUFFICIENT_AUTHORIZATION:
            return 'INSUFFICIENT_AUTHORIZATION';
        case CryptoErrorCode.NEGATIVE_AMOUNT:
            return 'NEGATIVE_AMOUNT';
        case CryptoErrorCode.ACCOUNT_IS_NOT_AVAILABLE:
            return 'ACCOUNT_IS_NOT_AVAILABLE';
        case CryptoErrorCode.QUOTE_NOT_FOUND:
            return 'QUOTE_NOT_FOUND';
        case CryptoErrorCode.TRANSFER_NOT_FOUND:
            return 'TRANSFER_NOT_FOUND';
        case CryptoErrorCode.SERVICE_UNAVAILABLE:
            return 'SERVICE_UNAVAILABLE';
        case CryptoErrorCode.INVALID_ADDRESS_PO_BOX:
            return 'INVALID_ADDRESS_PO_BOX';
        case CryptoErrorCode.INVALID_STATUS_FOR_ENROLLMENT:
            return 'INVALID_STATUS_FOR_ENROLLMENT';
        case CryptoErrorCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cryptoErrorCodeToJSON = cryptoErrorCodeToJSON;
/**
 * Crypto Service Public API
 */
class CryptoServiceClient {
    rpc;
    name = 'com.step.crypto.proto.CryptoService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/crypto';
    methods = [{
            name: 'GetIndex',
            requestType: exports.GetIndexRequest,
            responseType: exports.GetIndexResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'EnrollUser',
            requestType: exports.EnrollUserRequest,
            responseType: exports.EnrollUserResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetEnrollment',
            requestType: exports.GetEnrollmentRequest,
            responseType: exports.GetEnrollmentResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'DeactivateEnrollment',
            requestType: exports.DeactivateEnrollmentRequest,
            responseType: exports.DeactivateEnrollmentResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetAccounts',
            requestType: exports.GetAccountsRequest,
            responseType: exports.GetAccountsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'ConfirmEligibility',
            requestType: exports.ConfirmEligibilityRequest,
            responseType: exports.ConfirmEligibilityResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'Liquidate',
            requestType: exports.LiquidateRequest,
            responseType: exports.LiquidateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'Buy',
            requestType: exports.BuyRequest,
            responseType: exports.BuyResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'GetQuote',
            requestType: exports.GetQuoteRequest,
            responseType: exports.GetQuoteResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetDefaultCryptoBuyLimit',
            requestType: exports.GetDefaultCryptoBuyLimitRequest,
            responseType: exports.GetDefaultCryptoBuyLimitResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'SetUserDefinedLimit',
            requestType: exports.SetUserDefinedLimitRequest,
            responseType: exports.SetUserDefinedLimitResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetChart',
            requestType: exports.GetChartRequest,
            responseType: exports.GetChartResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Get the most recently calculated index value.
     */
    getIndex(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Enroll user into crypto rewards program.
     */
    enrollUser(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Check crypto rewards program enrollment status.
     */
    getEnrollment(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Deactivate crypto rewards enrollment.
     */
    deactivateEnrollment(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * TODO(CORE-241): Needs to deprecate crypto service's getAccounts endpoint.
     *
     * Get crypto accounts.
     */
    getAccounts(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Confirms the user's eligibility status for a crypto enrollment.
     */
    confirmEligibility(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Liquidate position.
     */
    liquidate(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Buy crypto.
     */
    buy(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get quote that can be used to execute a trade.
     */
    getQuote(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[8],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get default crypto buy limit configuration.
     */
    getDefaultCryptoBuyLimit(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[9],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Set user defined limit for crypto.
     */
    setUserDefinedLimit(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[10],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get chart data for crypto.
     */
    getChart(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[11],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.CryptoServiceClient = CryptoServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=crypto-service.js.map